(function(window, $, JSON, smartPlayerPreRollEventConstants, preRollView) {
   'use strict';

   window.TSC = window.TSC || {};

   window.TSC.preRollController = (function() {
      var _onPreRollStartedCallback;
      var $preRollView;
      var $window;

      $window = $(window);

      var preRollMessage = function(e) {
         e = e.originalEvent;
         // filter out non smart player events
         if (!e.data || typeof e.data.indexOf !== 'function' || e.data.indexOf('smartPlayerEventName') === -1) {
            return;
         }
         var message = JSON.parse(e.data);

         switch (message.smartPlayerEventName) {
            case smartPlayerPreRollEventConstants.PRE_ROLL_STARTED: {
               if (_onPreRollStartedCallback) {
                  _onPreRollStartedCallback();
               }
               break;
            }
            case smartPlayerPreRollEventConstants.PRE_ROLL_FINISHED: {
               switch (message.data.action) {
                  case smartPlayerPreRollEventConstants.PRE_ROLL_FINISHED_ACTIONS.REMOVE_NOW: {
                     destroyView();
                     break;
                  }
               }
               break;
            }
         }
      };

      var onIFrameContentLoaded = function() {
         $preRollView.removeClass('preRollHidden');
      };

      var destroyView = function() {
         if ($preRollView) {
            $window.unbind('message', preRollMessage);
            $preRollView.unbind('load', onIFrameContentLoaded);
            $preRollView.remove();
            $preRollView = undefined;
            _onPreRollStartedCallback = undefined;
         }
      };

      return {
         createView: function(preRollSrc, onPreRollStartedCallback) {
            $preRollView = $(preRollView.render(preRollSrc)).appendTo('body');
            $preRollView.bind('load', onIFrameContentLoaded);
            _onPreRollStartedCallback = onPreRollStartedCallback;
            $window.bind('message', preRollMessage);
         },
         viewExists: function() {
            return $preRollView !== undefined;
         },
         destroyView: destroyView
      };
   }());
}(window, window.jQuery, window.JSON, window.TSC.smartPlayerPreRollEventConstants, window.TSC.preRollView));
